import { IMarketYoyGrowthLogEntryApi } from '../api/types'
import { IMarketYoyGrowthLogEntry } from '../model/types'

export const mapMarketYoyGrowthLogEntryFromApi = (
  data: IMarketYoyGrowthLogEntryApi
): IMarketYoyGrowthLogEntry => ({
  id: data.ID,
  created: data.Created,
  modifiedBy: data.ModifiedBy,
  command: data.Command,
  changeLog: data.ChangeLog,
  planningEntryId: data.PlanningEntryID,
  rtm: data.RTM,
  metric: data.Metric,
  market: data.Market,
  category: data.Category,
})
